(function () {
  function syncBeforeImageWidth(container, beforeImg) {
    if (!container || !beforeImg) return;
    var w = container.offsetWidth;
    beforeImg.style.width = w + 'px';
    beforeImg.style.maxWidth = w + 'px';
  }

  function setSplit(container, percent) {
    percent = Math.max(2, Math.min(98, percent));
    container.style.setProperty('--split', percent + '%');
  }

  function pointerToPercent(container, clientX) {
    var rect = container.getBoundingClientRect();
    if (rect.width <= 0) return 50;
    return ((clientX - rect.left) / rect.width) * 100;
  }

  function initBeforeAfterContainer(container) {
    if (container.dataset.baInitialized === 'true') return;
    container.dataset.baInitialized = 'true';

    var beforeWrap = container.querySelector('.ba-before-wrapper');
    var beforeImg = container.querySelector('.ba-img.ba-before');
    var divider = container.querySelector('.ba-divider');

    if (!beforeWrap || !beforeImg) return;

    function sync() {
      syncBeforeImageWidth(container, beforeImg);
    }

    sync();

    var ro =
      typeof ResizeObserver !== 'undefined'
        ? new ResizeObserver(function () {
            sync();
          })
        : null;
    if (ro) ro.observe(container);

    window.addEventListener('resize', sync);

    var activePointerId = null;

    function onPointerMove(e) {
      if (activePointerId !== null && e.pointerId !== activePointerId) return;
      if (activePointerId === null && e.buttons !== 1 && e.type !== 'pointermove')
        return;
      setSplit(container, pointerToPercent(container, e.clientX));
    }

    function onPointerUp(e) {
      if (activePointerId !== null && e.pointerId === activePointerId) {
        container.releasePointerCapture(activePointerId);
        activePointerId = null;
      }
      window.removeEventListener('pointermove', onPointerMove);
      window.removeEventListener('pointerup', onPointerUp);
      window.removeEventListener('pointercancel', onPointerUp);
    }

    function onPointerDown(e) {
      if (e.button !== undefined && e.button !== 0) return;
      activePointerId = e.pointerId;
      try {
        container.setPointerCapture(e.pointerId);
      } catch (err) {}

      setSplit(container, pointerToPercent(container, e.clientX));

      window.addEventListener('pointermove', onPointerMove);
      window.addEventListener('pointerup', onPointerUp);
      window.addEventListener('pointercancel', onPointerUp);
    }

    container.addEventListener('pointerdown', onPointerDown);

    if (divider) {
      divider.style.pointerEvents = 'auto';
      divider.addEventListener('pointerdown', function (e) {
        e.stopPropagation();
        onPointerDown(e);
      });
    }
  }

  function initAllBeforeAfter(root) {
    root = root || document;
    root.querySelectorAll('.custom-before-after .ba-container').forEach(function (el) {
      initBeforeAfterContainer(el);
    });
  }

  function initSwiper() {
    if (typeof Swiper === 'undefined') return null;

    var el = document.querySelector('.custom-before-after .before-after-slider');
    if (!el || el.swiper) return el && el.swiper;

    var swiper = new Swiper('.custom-before-after .before-after-slider', {
      slidesPerView: 1,
      spaceBetween: 16,
      pagination: {
        el: '.custom-before-after .swiper-pagination',
        clickable: true,
      },
      navigation: {
        nextEl: '.custom-before-after .swiper-button-next-custom',
        prevEl: '.custom-before-after .swiper-button-prev-custom',
      },
      breakpoints: {
        750: {
          slidesPerView: 2,
          spaceBetween: 20,
        },
      },
      on: {
        init: function () {
          initAllBeforeAfter(document.querySelector('.custom-before-after'));
        },
        slideChange: function () {
          initAllBeforeAfter(document.querySelector('.custom-before-after'));
        },
      },
    });

    return swiper;
  }

  document.addEventListener('DOMContentLoaded', function () {
    initAllBeforeAfter(document);
    initSwiper();
  });

  document.addEventListener('shopify:section:load', function (e) {
    if (!e.target.classList.contains('custom-before-after')) return;
    initAllBeforeAfter(e.target);
    initSwiper();
  });
})();